import { ReactNode, useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../redux/store/hooks"
import { selectProfessionalAuthenticationState } from "../redux/ProfessionalAuthentication"
import { getJwt } from "../storage/jwt"
import { dispatchThunk } from "../redux/thunk/thunkify"
import { CheckProfessionalAuthSpecification, GetPatientsOfProfessionalSpecification, ValueType } from "pokal_api"
import { nothing } from "../util/void"
import { selectPokalApiConfiguredState } from "../redux/PokalApiToaster"
import { hideContextMenu } from "../redux/ContextMenu"
import { selectOnboardingIsRunningState } from "../redux/Onboarding"
import { useLocation, useNavigate } from "react-router-dom"
import {
    getPersistedLocationSelection,
    getPersistedPatientSelection,
    getPersistedValueTypeSelection
} from "../storage/selections"
import { selectDashboardPatient, selectDashboardValueType } from "../redux/ProfessionalDashboard"

interface RootLayoutProps {
    children: ReactNode
}

function RootLayout(props: RootLayoutProps) {
    const dispatch = useAppDispatch()

    const professionalAuthenticated = useAppSelector(
        selectProfessionalAuthenticationState
    )
    const onboardingIsRunning = useAppSelector(selectOnboardingIsRunningState)
    const pokalApiConfigured = useAppSelector(selectPokalApiConfiguredState)

    const location = useLocation()
    const navigate = useNavigate()

    useEffect(() => {
        const jwt = getJwt()
        let pathname = location.pathname
        if (pokalApiConfigured && !professionalAuthenticated && jwt !== null) {
            dispatchThunk(
                dispatch,
                CheckProfessionalAuthSpecification,
                nothing,
                {
                    do: () => {
                        const persistedPath = getPersistedLocationSelection()
                        const persistedPatient = getPersistedPatientSelection()
                        const persistedValueType = getPersistedValueTypeSelection()
                        if(persistedPath)
                            pathname = persistedPath
                        console.log(pathname)
                        console.log(persistedPatient)
                        console.log(persistedValueType)
                        if(persistedPatient) {
                            dispatchThunk(dispatch, GetPatientsOfProfessionalSpecification, nothing, {
                                do: result => {
                                    const match = result.find(s => s.id === persistedPatient)
                                    if(match) {
                                        dispatch(selectDashboardPatient(match))
                                        if(persistedValueType) {
                                            dispatch(selectDashboardValueType(Number(persistedValueType) as ValueType))
                                        }
                                        navigate(pathname)
                                    }
                                }
                            })
                        } else {
                            navigate(pathname)
                        }
                    }
                }
            )
        }
    }, [professionalAuthenticated, pokalApiConfigured])

    return (
        <div
            className={
                "fixed overflow-scroll " +
                (onboardingIsRunning
                    ? "top-[40px] bottom-0 left-[300px] right-0 "
                    : "top-0 bottom-0 left-0 right-0 ")
            }>
            <div
                onContextMenu={(e) => {
                    e.preventDefault()
                }}
                onClick={() => {
                    dispatch(hideContextMenu())
                }}
                className={
                    "w-full min-h-screen bg-gradient-to-r from-rose-50 to-slate-200 flex flex-col overflow-x-scroll"
                }>
                {props.children}
            </div>
        </div>
    )
}

export default RootLayout
